module.exports = __webpack_public_path__ + "static/img/SPIN1.65dbc1f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/simba/SPIN1.png
// module id = yjKA
// module chunks = 0